import { render, staticRenderFns } from "./ElFormErrors.vue?vue&type=template&id=4dcd2d8a"
import script from "./ElFormErrors.vue?vue&type=script&lang=js"
export * from "./ElFormErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports